import React from "react";
import { MinusCircle, PlusCircle, Undo2 } from "lucide-react";
import { fmtDate } from "@/lib/format";

export function AdjustmentList({ items = [], onCancel }) {
  if (!items.length) return <div className="text-xs text-stone-400" data-testid="adjust-history-empty">Nessuna rettifica.</div>;
  return (
    <ul className="space-y-2" data-testid="adjust-history">
      {items.map((a) => {
        const minus = a.kind === "riduzione";
        const Icon = minus ? MinusCircle : PlusCircle;
        return (
          <li key={a.id} data-testid={`adjust-item-${a.id}`} className={`flex items-start gap-2.5 rounded-lg border px-3 py-2 text-sm ${a.cancelled ? "bg-stone-50 border-stone-200 opacity-60" : "bg-white border-stone-200"}`}>
            <Icon size={16} className={`mt-0.5 shrink-0 ${minus ? "text-red-600" : "text-emerald-600"}`} />
            <div className="flex-1 min-w-0">
              <div className={`font-medium ${a.cancelled ? "line-through" : ""}`}>{minus ? "−" : "+"}{a.hours}h</div>
              <div className="text-stone-600 text-xs whitespace-pre-line">{a.reason}</div>
              <div className="text-[11px] text-stone-400 mt-0.5">
                {fmtDate(a.created_at)}{a.created_by_name ? ` · ${a.created_by_name}` : ""}
                {a.cancelled && <> · annullata il {fmtDate(a.cancelled_at)}</>}
              </div>
            </div>
            {onCancel && !a.cancelled && (
              <button onClick={() => onCancel(a)} title="Annulla rettifica" data-testid={`adjust-cancel-${a.id}`} className="text-stone-400 hover:text-red-600 transition-colors duration-150">
                <Undo2 size={15} />
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
